/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ version: NonNullable<unknown> }} Community_News_VersionInputs */

const en_us2_community_news_version = /** @type {(inputs: Community_News_VersionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Version ${i?.version}`)
};

const pt_br2_community_news_version = /** @type {(inputs: Community_News_VersionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Versão ${i?.version}`)
};

const es_419_community_news_version = /** @type {(inputs: Community_News_VersionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Versión ${i?.version}`)
};

const pt_pt2_community_news_version = /** @type {(inputs: Community_News_VersionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Versão ${i?.version}`)
};

const fr_fr2_community_news_version = /** @type {(inputs: Community_News_VersionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Version ${i?.version}`)
};

const de_de2_community_news_version = /** @type {(inputs: Community_News_VersionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Version ${i?.version}`)
};

const it_it2_community_news_version = /** @type {(inputs: Community_News_VersionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Versione ${i?.version}`)
};

/**
* | output |
* | --- |
* | "Version {version}" |
*
* @param {Community_News_VersionInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const community_news_version = /** @type {((inputs: Community_News_VersionInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Community_News_VersionInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_community_news_version(inputs)
	if (locale === "es-419") return es_419_community_news_version(inputs)
	if (locale === "pt-PT") return pt_pt2_community_news_version(inputs)
	if (locale === "fr-FR") return fr_fr2_community_news_version(inputs)
	if (locale === "de-DE") return de_de2_community_news_version(inputs)
	if (locale === "it-IT") return it_it2_community_news_version(inputs)
	return en_us2_community_news_version(inputs)
});
export { community_news_version as "community.news_version" }